import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

var _dec, _class;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';
import moment from 'moment';
import { connect, ReactReduxContext, Provider } from 'react-redux';
import Helmet from 'react-helmet';
import { initialize, reduxForm, Field } from 'redux-form';
import { sendAgreementEmail, downloadAgreement } from 'redux/modules/newContract';
import calculateContract from '../../helpers/calculateContract';
import { AgreementPreview, ModalTopBar, NewContractForm, PageHeader, SecondaryButton, Spinner, BillingForm } from 'components';
import { LeftNavLayout } from 'containers';
import Dialog from 'material-ui/Dialog';
import { showStripeError, initialSubscription } from 'redux/modules/billing';
var ContractPreview = (_dec = connect(function (state) {
  return {
    user: state.auth.user,
    contract: state.contract,
    theme: state.theme,
    form: state.form,
    config: state.config
  };
}, {
  sendAgreementEmail: sendAgreementEmail,
  showStripeError: showStripeError,
  initialSubscription: initialSubscription,
  downloadAgreement: downloadAgreement
}), _dec(_class = /*#__PURE__*/function (_Component) {
  _inherits(ContractPreview, _Component);

  var _super = _createSuper(ContractPreview);

  function ContractPreview(props) {
    var _this2;

    _classCallCheck(this, ContractPreview);

    _this2 = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this2), "handleSendEmail", function () {
      _this2.setState({
        agreementState: 0
      });

      _this2.props.sendAgreementEmail({
        uuid: _this2.props.contract.uuid
      }).then(function () {
        _this2.setState({
          agreementState: 1
        });
      })["catch"](function (err) {
        _this2.setState({
          agreementState: 2
        });
      });
    });

    _defineProperty(_assertThisInitialized(_this2), "downloadAgreement", function (id) {
      _this2.props.downloadAgreement(id).then(function (res) {
        window.open(res.data, '_blank' // <- This is what makes it open in a new window.
        );
      });
    });

    _defineProperty(_assertThisInitialized(_this2), "handleEnterPaymentDetails", function () {
      _this2.setState({
        paymentDetailInputModal: true
      });
    });

    _defineProperty(_assertThisInitialized(_this2), "componentDidMount", function () {
      // So testing can get past this (`Stripe` will not be in scope in Jest because it is loaded from a linked JS file)
      global.Stripe || global.window && global.window.Stripe ? Stripe.setPublishableKey(_this2.props.config.stripePublicKey) : null;
    });

    _defineProperty(_assertThisInitialized(_this2), "handleBillingFormSubmit", function () {
      if (_this2.state.checkoutInProgress) {
        return console.error('Checkout is already in progress. Cannot initiate another checkout right now.');
      }

      _this2.setState({
        checkoutInProgress: true
      });

      var _this = _assertThisInitialized(_this2);

      var formData = _objectSpread(_objectSpread({}, _this2.props.form.billing.values), calculateContract(_this2.props.contract));

      Stripe.card.createToken({
        number: formData.cardNumber,
        exp_month: formData.expMonth,
        exp_year: formData.expYear,
        cvc: formData.cvc,
        name: formData.name,
        address_zip: formData.postcode
      }, function (status, response) {
        if (response.error) {
          return _this2.props.showStripeError(response.error);
        }

        if (status === 200) {
          var contractAmounts = calculateContract(_this2.props.contract);
          formData.paymentSourceId = response.id;
          formData.monthlyAmountInCents = formData.totalDueToday;

          _this2.props.initialSubscription(formData, _this2.props.params.contractUuid).then(function () {
            _this2.setState({
              paymentDetailInputModal: false,
              checkoutInProgress: false
            });

            window.location.reload();
          })["catch"](function (err) {
            return console.error(err);
          });
        } else {
          _this.setState({
            checkoutInProgress: false
          });

          console.log(status, response);
        }
      });
    });

    _this2.state = {
      agreementState: -1
    };
    return _this2;
  }

  _createClass(ContractPreview, [{
    key: "render",
    value: function render() {
      var _this3 = this;

      var paymentDetailEntryType = this.props.contract ? this.props.contract.paymentDetailEntryType : 1;
      var paymentStatusString;
      var warningPaymentStatusString;

      if (this.props.contract.billingAccount && this.props.contract.billingAccount.id) {
        if (!this.props.contract.BillingAccountSubscription && this.props.contract.billingAccount.PaymentMethodId == 6) {
          warningPaymentStatusString = /*#__PURE__*/React.createElement("span", null, "Customer has been created and a billing account has been created for them,", /*#__PURE__*/React.createElement("br", null), "but a subscription was not created properly.", /*#__PURE__*/React.createElement("br", null), "Charge may need to be retried.");
        } else if (this.props.contract.billingAccount.PaymentMethodId === 6) {
          paymentStatusString = 'Customer has been charged via Stripe and a billing account has been created for them.';
        } else if (this.props.contract.billingAccount.PaymentMethodId === 7) {
          paymentStatusString = 'Customer is billed through Henry Schein. It is the responsibility of the Sales Rep to ensure this customer is being charged.';
        } else if (this.props.contract.billingAccount.PaymentMethodId === 9) {
          paymentStatusString = 'Customer is billed through some other external system. Please make sure this customer is paying somehow.';
        } else {
          paymentStatusString = 'Customer has a billing account in some unexpected way. Please make sure this customer is paying somehow.';
        }
      }

      var isMultilocationContract = this.props.contract.isPartner && this.props.contract.ContractPartners && this.props.contract.ContractPartners.length && this.props.contract.ContractPartners.some(function (cp) {
        return cp.partnerType === 'multilocation';
      });
      var isAffiliateContract = this.props.contract.isPartner && this.props.contract.ContractPartners && this.props.contract.ContractPartners.length && this.props.contract.ContractPartners.some(function (cp) {
        return cp.partnerType === 'affiliate';
      });
      return /*#__PURE__*/React.createElement(LeftNavLayout, {
        sidebar: "admin",
        wrapStyle: {
          flex: '1 1 auto',
          paddingBottom: 36
        },
        appLayoutInnerStyle: {
          display: 'flex',
          flex: '1 1 auto',
          padding: 0,
          overflow: 'hidden',
          overflowY: 'auto',
          height: '100%'
        }
      }, /*#__PURE__*/React.createElement(Helmet, {
        title: this.props.contract.isPartner ? "".concat(isMultilocationContract ? 'Multilocation' : isAffiliateContract ? 'Affiliate' : 'Partner', " Agreement Review") : 'Customer Agreement Review'
      }), /*#__PURE__*/React.createElement(ModalTopBar, {
        backUrl: "/global/agreements",
        showCloseBtn: false,
        style: {
          position: 'static',
          marginBottom: 24
        },
        backLabel: "View All Agreements"
      }), /*#__PURE__*/React.createElement("div", {
        className: "row",
        style: {
          paddingLeft: 36
        }
      }, /*#__PURE__*/React.createElement("div", {
        className: "col-xs-12"
      }, /*#__PURE__*/React.createElement(PageHeader, {
        primary: this.props.contract.isPartner ? "".concat(isMultilocationContract ? 'Multilocation' : isAffiliateContract ? 'Affiliate' : 'Partner', " Agreement") : 'Customer Agreement',
        secondary: "Review"
      }))), this.props.contract.signedAt ? /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
        style: {
          color: '#417505',
          marginLeft: 55,
          lineHeight: '20px',
          marginBottom: 12,
          textAlign: 'center'
        }
      }, /*#__PURE__*/React.createElement("i", {
        className: "fa fa-check",
        style: {
          fontSize: 20,
          marginRight: 10
        }
      }), "Customer has signed the contract."), paymentDetailEntryType !== 1 && /*#__PURE__*/React.createElement("div", {
        style: {
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center'
        }
      }, /*#__PURE__*/React.createElement("div", {
        style: {
          color: '#417505',
          marginLeft: 55,
          lineHeight: '20px',
          marginBottom: 12,
          textAlign: 'center'
        }
      }, this.props.contract.billingAccount && this.props.contract.billingAccount.id && !warningPaymentStatusString ? /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement("i", {
        className: "fa fa-check",
        style: {
          fontSize: 20,
          marginRight: 10
        }
      }), paymentStatusString, ' ') : /*#__PURE__*/React.createElement("span", {
        style: {
          textAlign: 'center'
        }
      }, warningPaymentStatusString && /*#__PURE__*/React.createElement("div", {
        style: {
          color: 'orange',
          textAlign: 'center',
          marginBottom: 10
        }
      }, /*#__PURE__*/React.createElement("i", {
        className: "fa fa-exclamation-triangle",
        style: {
          fontSize: 20,
          marginRight: 10
        }
      }), warningPaymentStatusString, ' '), /*#__PURE__*/React.createElement(SecondaryButton, {
        onClick: this.handleEnterPaymentDetails,
        label: 'Enter Payment Details',
        style: {
          marginLeft: 10
        }
      }))), /*#__PURE__*/React.createElement(ReactReduxContext.Consumer, null, function (ctx) {
        return /*#__PURE__*/React.createElement(Dialog, {
          title: 'Enter Customer Payment Details',
          titleStyle: {
            color: _this3.props.theme.colors.primaryColor
          },
          autoScrollBodyContent: true,
          open: _this3.state.paymentDetailInputModal,
          onRequestClose: function onRequestClose() {
            return _this3.setState({
              paymentDetailInputModal: false
            });
          }
        }, /*#__PURE__*/React.createElement(Provider, {
          store: ctx.store
        }, /*#__PURE__*/React.createElement(BillingForm, {
          onSubmit: _this3.handleBillingFormSubmit,
          showTotal: false,
          isBusy: _this3.state.checkoutInProgress || _this3.props.settingAdsPaymentMethod
        })));
      })), /*#__PURE__*/React.createElement("div", {
        style: {
          marginLeft: 55,
          marginTop: 32,
          marginBottom: 12,
          textAlign: 'center'
        }
      }, "Agreement signed on", ' ', moment(this.props.contract.signedAt).format('MM/DD/YY'), " from IP #", this.props.contract.ipAddress, /*#__PURE__*/React.createElement("a", {
        href: "#",
        style: {
          marginLeft: 32
        },
        onClick: function onClick() {
          return _this3.downloadAgreement(_this3.props.contract.pdfReceiptS3Id);
        }
      }, "Download signed agreement"))) : /*#__PURE__*/React.createElement("div", {
        className: "row",
        style: {
          color: 'red',
          justifyContent: 'center',
          lineHeight: '20px',
          marginBottom: 12
        }
      }, /*#__PURE__*/React.createElement("i", {
        className: "fa fa-close",
        style: {
          fontSize: 20,
          marginRight: 10
        }
      }), "Customer has NOT signed the contract.", ' '), this.state.agreementState === -1 && !this.props.contract.signedAt && /*#__PURE__*/React.createElement("div", {
        className: "row",
        style: {
          justifyContent: 'center'
        }
      }, /*#__PURE__*/React.createElement(Link, {
        to: this.props.contract.isPartner ? "/global/agreements/".concat(isMultilocationContract ? 'multilocation' : isAffiliateContract ? 'affiliate' : 'partner', "/edit/").concat(this.props.contract.uuid) : "/global/agreements/edit/".concat(this.props.contract.uuid)
      }, /*#__PURE__*/React.createElement(SecondaryButton, {
        label: "Edit Agreement",
        style: {
          marginRight: 10
        }
      })), /*#__PURE__*/React.createElement(SecondaryButton, {
        onClick: this.handleSendEmail,
        label: 'Send to customer for signing',
        style: {
          marginLeft: 10
        }
      })), this.state.agreementState === 0 && /*#__PURE__*/React.createElement("div", {
        className: "row"
      }, /*#__PURE__*/React.createElement("div", {
        className: "col-xs-12"
      }, /*#__PURE__*/React.createElement("h3", {
        style: {
          textAlign: 'center'
        }
      }, "Sending Agreement...")), /*#__PURE__*/React.createElement("div", {
        className: "col-xs-12",
        style: {
          height: 75,
          marginTop: 12,
          position: 'relative'
        }
      }, /*#__PURE__*/React.createElement(Spinner, {
        center: true
      }))), this.state.agreementState === 1 && /*#__PURE__*/React.createElement("div", {
        className: "row"
      }, /*#__PURE__*/React.createElement("h3", {
        style: {
          textAlign: 'center',
          width: '100%'
        }
      }, "Agreement sent to ", this.props.contract.email)), this.state.agreementState === 2 && /*#__PURE__*/React.createElement("div", {
        className: "row"
      }, /*#__PURE__*/React.createElement("h3", {
        style: {
          textAlign: 'center',
          width: '100%'
        }
      }, "There was an error sending Agreement.")), /*#__PURE__*/React.createElement(AgreementPreview, {
        isMultilocationContract: isMultilocationContract,
        isAffiliateContract: isAffiliateContract
      }));
    }
  }]);

  return ContractPreview;
}(Component)) || _class);
export { ContractPreview as default };